import React from "react";

const EnrollTooltip = () => {
  return (
    <div>
      The Medicare Annual Enrollment Period (AEP) for 2024 plans (effective date
      January 1) runs from October 15 through December 7. Please revisit our
      website on or after October 15 to complete your online enrollment.
      <br />
      Need assistance or a reminder? Give us a call at{" "}
      <span className="color-primary text-underline">
        <a href="tel:18882938272">1-888-293-8272</a>
      </span>{" "}
      (TTY: 711).
    </div>
  );
};

export default EnrollTooltip;
